import { isMatch, lightFormat } from 'date-fns'

export default function validatePersonalNr(virgin) {
    let res = false;
    virgin = (String(virgin)).replace(/\D/gm, '').trim();
    const isEmpty = virgin.length === 0;
    const pnRegex = /^[0-9]{2}[0156]{1}[0-9]{1}[0123]{1}[0-9]{4,5}$/;
    const userYear = parseInt(virgin.substring(0,2));
    let dateControl = virgin.substring(0,6);
    try {
        const mPlaceInt = parseInt(dateControl[2]);
        if (mPlaceInt > 4) {
            dateControl = dateControl.substring(0, 2) + String(mPlaceInt - 5) + dateControl.substring(3);
        }
    } catch(e) {}
    if (!isNaN(userYear) && isMatch(dateControl, 'yyMMdd')) {
        let controlCount = 10;
        if (userYear < 54 && userYear > parseInt(lightFormat(new Date(), 'yy'))) {
            controlCount = 9;
        }
        if (controlCount === 10) {
            const cmod = parseInt(virgin) % 11;
            res = (cmod === 0 && virgin.length === 10 && pnRegex.test(virgin)) 
        } else {
            res = pnRegex.test(virgin);
        }
     } else {
        res = false;
    }
    return { res, virgin, isEmpty };
}

export function checkMailVal(userIn) {
    var ctrlRgx = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,14}))$/i;
    if (ctrlRgx.test(userIn)) {
        return true;
    }
    else {
        return false;
    }
}

export function validateMsisdn(msisdn) {
    var res = true;
    msisdn = (String(msisdn || '')).replace(/ /g, '');
    if (msisdn.length < 9 || (msisdn.length === 9 && msisdn.slice(0,1) == '0') || isNaN(msisdn)) {
        res = false;
    }
    return res;
}